var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17423_102657)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0373 28.7341C10.9833 28.9215 11.0373 29.1267 11.174 29.2636C11.2749 29.3644 11.4154 29.422 11.5558 29.422C11.6062 29.422 11.6567 29.4149 11.7036 29.4004L16.7384 27.9634L12.4742 23.6992L11.0373 28.7341Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5557 29.4393C11.408 29.4393 11.2676 29.3817 11.1632 29.2773C11.0191 29.1332 10.9651 28.9243 11.0226 28.7299L12.4704 23.666L16.778 27.9735L11.7069 29.4177C11.6566 29.4322 11.6061 29.4393 11.5557 29.4393ZM12.4849 23.7309L11.0551 28.737C11.0046 28.9208 11.0551 29.1152 11.1884 29.2484C11.2856 29.3457 11.4188 29.3997 11.5557 29.3997C11.6025 29.3997 11.6529 29.3925 11.6998 29.3781L16.7059 27.9484L12.4849 23.7309Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9472 13.7799L26.6602 11.493C26.3505 11.1868 25.9472 11.0176 25.5114 11.0176C25.0792 11.0176 24.6722 11.1868 24.366 11.4894L23.2207 12.6346L27.7983 17.2123L28.9437 16.0669C29.2498 15.7608 29.4154 15.3538 29.4154 14.9216C29.419 14.4894 29.2498 14.0861 28.9472 13.7799Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.802 17.2379L23.1992 12.6351L24.3552 11.479C24.665 11.1692 25.0755 11 25.5114 11C25.9508 11 26.3614 11.1692 26.6676 11.479L28.9545 13.766C29.2642 14.0757 29.4334 14.4863 29.4334 14.922C29.4334 15.3615 29.2642 15.7721 28.9545 16.0782L27.802 17.2379ZM23.2496 12.6351L27.802 17.1875L28.9329 16.0565C29.2354 15.7541 29.4011 15.3542 29.4011 14.9257C29.4011 14.4972 29.2354 14.0973 28.9329 13.7949L26.6459 11.5042C26.3434 11.2017 25.9399 11.036 25.5114 11.036C25.0829 11.036 24.683 11.2017 24.3806 11.5042L23.2496 12.6351Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.082 22.7778L22.4613 13.3984L27.0402 17.9773L17.6609 27.3567L13.082 22.7778Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6601 27.3831L13.0537 22.7768L22.461 13.373L27.0638 17.9759L17.6601 27.3831ZM13.1077 22.7768L17.6601 27.3291L27.0133 17.9759L22.461 13.4236L13.1077 22.7768Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17423_102657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.78e5b52ba1322384d141c494058e465c.svg";
export { ForwardRef as ReactComponent };